import { Integration } from "../../types";
import { Typography } from "@mui/material";

export const CustomSetupForm: React.FC<{
  integration: Integration,
  onSubmit: (updatedIntegration: Integration) => void
}> = () => {
  return <Typography>
    Work in progress
  </Typography>
};
